import { render } from "./WaiverModal.vue?vue&type=template&id=450fe80e&scoped=true"
import script from "./WaiverModal.vue?vue&type=script&lang=js"
export * from "./WaiverModal.vue?vue&type=script&lang=js"

import "./WaiverModal.vue?vue&type=style&index=0&id=450fe80e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450fe80e"]])

export default __exports__